import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { CurrentRatioType, DebtRatioType, RatioType, WorkingCapitalType } from "../../types";
import { EquityRatioType, NetWorthType } from "../../types/RatioType";

type ParamsType = {
    date: string;
    location_id?: string;
    type: keyof typeof typeMapping;
};

// Mapping tipe ke endpoint dan jenis data
const typeMapping = {
    current_ratio: {
        endpoint: "/finance_ratio/current_ratio/",
        typeData: {} as CurrentRatioType,
    },
    debt_ratio: {
        endpoint: "/finance_ratio/debt_ratio/",
        typeData: {} as DebtRatioType,
    },
    net_worth: {
        endpoint: "/finance_ratio/net_worth_ratio/",
        typeData: {} as NetWorthType,
    },
    equity_ratio: {
        endpoint: "/finance_ratio/debt_to_equity_ratio/",
        typeData: {} as EquityRatioType,
    },
    working_capital: {
        endpoint: "/finance_ratio/working_capital/",
        typeData: {} as WorkingCapitalType,
    },
} as const;

export function useCurrenRatio({ date, location_id, type }: ParamsType) {
    const api = useApi();
    const [data, setData] = useState<RatioType | null>(null);

    const params: Record<string, string | number> = {
        year_month: date,
        ...(location_id && { location_id }),
    };

    const fetchData = () => {
        const typeConfig = typeMapping[type]; 
        if (!typeConfig) return;

        api.get(typeConfig.endpoint, { params })
            .then((res: SuccessFetch<{ payload: RatioType }>) => {
                const payload = res.data.payload;
                setData(payload);
            })
            .catch(() => {
                setData(null);
            });
    };

    useEffect(() => {
        fetchData();
        return () => setData(null);
        // eslint-disable-next-line
    }, [date, location_id, type]);

    return { fetchData, data };
}
